var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 74,
    viewBox: "0 0 50 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4996 29.8065H30.6659L35.6696 5.01675C36.1847 2.3607 32.7999 0.885115 31.181 3.02471L3.51362 40.2094C2.26271 41.8325 3.44004 44.1935 5.50038 44.1935H19.3341L14.3304 68.9833C13.8153 71.6393 17.2002 73.1149 18.819 70.9753L46.4864 33.7168C47.7373 32.1675 46.56 29.8065 44.4996 29.8065Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.66b092fa6bfdbec8df7df8339892678d.svg";
export { ForwardRef as ReactComponent };